import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const MainImage = ({ image }) => {
  const base = 'order-1 lg:order-2 relative grow w-full lg:max-w-[510px] aspect-[3/4]'
  
  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default MainImage
